module.exports = __webpack_public_path__ + "static/media/answer.4baed00b.mp3";